import { SelectColumnsWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('SelectColumns')
export class SelectColumnsConnectorProvider extends ConnectorProvider<SelectColumnsWorkflowNode> {}
